export default __webpack_public_path__ + "media/zurb/img/legacy/icons/press/techi-0416ffdf275a40bd12acf4a38840838d.png";